import { useLayoutEffect, useRef } from 'react';

export function createHistoryRequestGate() {
  let version = 0;
  let active = true;
  const pending = new Set();
  const loaded = new Set();
  return {
    reset() { version += 1; active = true; pending.clear(); loaded.clear(); },
    invalidate() { version += 1; active = false; pending.clear(); loaded.clear(); },
    begin(page, append) {
      if (!active || (append && (pending.has(1) || pending.has(page) || loaded.has(page) || !loaded.has(page - 1)))) return null;
      if (!append) { version += 1; pending.clear(); loaded.clear(); }
      const request = { version, page };
      pending.add(page);
      return request;
    },
    current(request) { return active && request.version === version; },
    finish(request, applied) {
      if (!this.current(request)) return false;
      pending.delete(request.page);
      if (applied) loaded.add(request.page);
      return true;
    },
  };
}

export default function useHistoryRequestGate(key, revision) {
  const gate = useRef(null);
  if (!gate.current) gate.current = createHistoryRequestGate();
  useLayoutEffect(() => {
    const requests = gate.current;
    requests.reset();
    return () => requests.invalidate();
  }, [key, revision]);
  return gate.current;
}
